import { render } from "./ListeArticle.vue?vue&type=template&id=41815546&ts=true"
import script from "./ListeArticle.vue?vue&type=script&lang=ts"
export * from "./ListeArticle.vue?vue&type=script&lang=ts"

import "./ListeArticle.vue?vue&type=style&index=0&id=41815546&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__